import styled from 'styled-components';

export const PlanForBetterDiv = styled('div')`
  margin-top: 2rem;

  .article-teaser-wrapper__heading {
    display: none;
  }

  [data-cy='plan4BetterSectionHeader'] {
    padding-top: 0 !important;
    margin-bottom: 40px !important;
  }
`;
